import React, { Component } from "react";
import "w3-css/3/w3.css";

class FromGramsButton extends Component {
  handleClickButon = buttonId => {
    this.props.grUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Grams to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <OuncesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <PoundsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <StonesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilogramsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromOuncesButton extends Component {
  handleClickButon = buttonId => {
    this.props.ozUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Ounces to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <GramsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <PoundsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <StonesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilogramsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromPoundsButton extends Component {
  handleClickButon = buttonId => {
    this.props.pdUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Pounds to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <GramsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <OuncesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <StonesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilogramsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromStonesButton extends Component {
  handleClickButon = buttonId => {
    this.props.stUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Stones to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <GramsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <OuncesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <PoundsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilogramsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromKilogramsButton extends Component {
  handleClickButon = buttonId => {
    this.props.klUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Kilograms to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <GramsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <OuncesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <PoundsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <StonesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class GramsButton extends Component {
  handleUpButton = () => {
    let name = "gr";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="grams"
        >
          Grams
        </button>
      </span>
    );
  }
}

class OuncesButton extends Component {
  handleUpButton = () => {
    let name = "oz";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="ounces"
        >
          Ounces
        </button>
      </span>
    );
  }
}

class PoundsButton extends Component {
  handleUpButton = () => {
    let name = "pd";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="pounds"
        >
          Pounds
        </button>
      </span>
    );
  }
}

class StonesButton extends Component {
  handleUpButton = () => {
    let name = "st";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="stones"
        >
          Stones
        </button>
      </span>
    );
  }
}

class KilogramsButton extends Component {
  handleUpButton = () => {
    let name = "kl";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="kilograms"
        >
          Kilograms
        </button>
      </span>
    );
  }
}

export {
  FromGramsButton,
  FromOuncesButton,
  FromPoundsButton,
  FromStonesButton,
  FromKilogramsButton
};
